import AudienceIcon from '@icons/audience.svg?react';
import CalendarIcon from '@icons/calendar.svg?react';
import CloseDialogIcon from '@icons/close-dialog.svg?react';
import FolderIcon from '@icons/folder.svg?react';
import LocationIcon from '@icons/location.svg?react';
import ShapesIcon from '@icons/shapes.svg?react';
import { PrimaryButton as Button } from '@ui/buttons';
import { DialogModal } from '@ui/dialogModal';
import { generateKey } from '@utils';
import { Fragment } from 'react';
import Styled from './SourceInfoDialog.styled';

interface Props {
  open: boolean;
  onClose: () => void;
}

function SourceInfoDialog({ open, onClose }: Props) {
  const content = (
    <Styled.DescriptionList>
      {[
        {
          icon: <AudienceIcon />,
          title: 'Audience',
          text: 'The specific group of people you are intending to reach.'
        },
        {
          icon: <ShapesIcon />,
          title: 'Topic',
          text: `The areas of focus that we will use to reveal insights into the
        audience's preferences, behaviors, and interests.`
        },
        {
          icon: <CalendarIcon />,
          title: 'Timeframe',
          text: 'This includes data from the last four GWI surveys (Waves).'
        },
        {
          icon: <LocationIcon />,
          title: 'Location',
          text: `The areas of focus that we will use to reveal insights into the
        audience's preferences, behaviors, and interests.`
        },
        {
          icon: <FolderIcon />,
          title: 'Data set',
          text: 'Collection of responses and behavioral data from an specific survey.'
        }
      ].map((item, index) => (
        <Fragment key={generateKey(`${item.title}-${index}`)}>
          <Styled.DescriptionTitle data-testid="source-info-description-title">
            {item.icon}
            <span>{item.title}</span>
          </Styled.DescriptionTitle>
          <Styled.DescriptionDetails data-testid="source-info-description-details">
            {item.text}
          </Styled.DescriptionDetails>
        </Fragment>
      ))}
    </Styled.DescriptionList>
  );

  return (
    <DialogModal
      title="Sources"
      headerButton={
        <Styled.CloseButton data-testid="source-info-close">
          <CloseDialogIcon onClick={onClose} />
        </Styled.CloseButton>
      }
      main={content}
      footerRight={
        <Styled.FooterButton>
          <Button
            testId="source-info-confirm"
            className="button"
            onClick={onClose}>
            Ok, got it
          </Button>
        </Styled.FooterButton>
      }
      open={open}
      testId="source-info-dialog"
      onClose={onClose}
    />
  );
}

export default SourceInfoDialog;
